import React from 'react';
import { Header } from 'src/design/organisms/Header';
import { ChangeTypeForm } from 'src/routes/Settings/ChangeTypes/components/ChangeTypeForm';

export const CreateChangeType: React.FC = () => {
  return (
    <>
      <Header
        breadcrumbProps={{
          items: [
            { text: 'Settings', href: '/settings' },
            { text: 'Change Types', href: '/settings/change-types' },
            { text: 'Create Change Type' },
          ],
        }}
        title="Create Change Type"
        helpText="Create a change type that can be assigned to changes."
      />
      <ChangeTypeForm />
    </>
  );
};
